(async () => {
    const { 
        loadScript,
        loadStyle
    } = await import(window.theme.modules.utils);

    const baseComponent = await import(window.theme.modules.baseComponent);

    customElements.define('video-bg', class extends baseComponent.default {
        elements = {
            player: '[data-player]'
        }

        playerInited = false;

        async render() {
            this.on('stopVideoBg', () => {
                if(this.player) {
                    this.player.pause();
                }
            })
            this.on('playVideoBg', () => {
                if(this.player) {
                    this.player.play();
                }
            })
        }

        async onIntersect(isIntersecting) {
            if (isIntersecting) {
                if(!this.player) {
                    this.setAttribute('loading', '');
                    await this.initPlayer();
                } else {
                    this.player.play();
                }
            }
        if(!isIntersecting && this.player) {
                this.player.pause();
            }
        }

        async initPlayer() {
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    if (isMobile && this.$player.tagName === 'VIDEO') {
    const source = this.$player.querySelector('source');
    if (source) {
        this.$player.src = source.src;
    }
    this.$player.muted = true;
    this.$player.loop = true;
    this.$player.autoplay = true;
    this.$player.setAttribute('playsinline', '');
    this.$player.setAttribute('webkit-playsinline', '');
    this.$player.load();
    this.playerInited = true;
    this.player = { 
        play: () => this.$player.play(), 
        pause: () => this.$player.pause() 
    };
    this.removeAttribute('loading');
    this.$player.play().catch(() => {});
    return;
}

    loadStyle('https://cdn.plyr.io/3.6.8/plyr.css');
    if(!window.Plyr) {
        await loadScript(window.theme.scripts.Plyr);
    }
    this.playerInited = true;
    this.player = new window.Plyr(this.$player, {
        muted: true,
        loop: { active: this.$player.tagName === 'VIDEO' } 
    });
    this.player.on('ended', () => {
        this.player.restart();
    })
    this.player.on('ready', () => {
        this.player.play();
        this.player.decreaseVolume(100);
    })
    this.player.on('playing', () => {
        this.removeAttribute('loading');
    })
}
    });
})();